import styled from 'styled-components/macro';
import { TicketsFiltersLabelsText } from '../../common/fontElements';
import { SelectHolderComponent } from '../../common/dropDownComponents';

export const SelectHolder = styled(SelectHolderComponent)`
  width: 100%;
  margin-left: ${(props) => (props.label ? '3px' : '0px')};
  margin-bottom: 0px;
`;

export const SelectOuterHolder = styled.div`
  width: 100%;
  max-width: 700px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;
`;

export const Label = styled(TicketsFiltersLabelsText)`
  font-family: 'Lato-Bold', sans-serif;
  line-height: 25px;
`;
